const order = {
    getlist: 'order/getlist',
    get: 'order/get-by-admin',
    changestatus: 'order/change-status',
    updatepostaltrackingcode: 'order/update-postaltrackingcode',
}
export default order
